import { css } from 'styled-components';
import colors from '../settings/colors';

// Gradient text effect
export const gradientText = css`
  background: linear-gradient(
    135deg,
    ${colors.gradientStart} 0%,
    ${colors.gradientEnd} 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  display: inline-block;
`;

// Gradient backgrounds
export const primaryGradient = css`
  background: linear-gradient(
    135deg,
    ${colors.gradientStart} 0%,
    ${colors.gradientEnd} 100%
  );
`;

export const lightGradient = css`
  background: linear-gradient(
    180deg,
    ${colors.bgLight} 0%,
    ${colors.bgLavender} 100%
  );
`;

export const shimmerGradient = css`
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.3) 50%,
    transparent 100%
  );
  background-size: 200% 100%;
`;

// Glassmorphism effect
export const glassmorphism = css`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
`;

// Button gradient with hover
export const buttonGradient = css`
  ${primaryGradient};
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    transition: left 0.6s ease;
  }

  &:hover::before {
    left: 100%;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 30px rgba(124, 58, 237, 0.3);
  }
`;
